module.exports = __webpack_public_path__ + "static/wix_apple-pay-51f933424d3af373109529cf3fe8e84c.svg";